export const INSURANCE_LINKING_SERVER_ERROR_CODES_FORM_ACCESSORS_MAP = new Map([
  [1117, { accessKey: 'member_id', redirectUrl: 'https://api.whatsapp.com/send?phone=6282368285000' }],
  [1118, { accessKey: 'policy_number', redirectUrl: '' }],
  [1119, { accessKey: 'date_of_birth', redirectUrl: '' }],
  [1120, { accessKey: 'policy_holder_name', redirectUrl: '' }],
  [1123, { accessKey: '', redirectUrl: 'https://api.whatsapp.com/send?phone=6282368285000' }],
]);

export const ASSETS_SHARED_PATH = 'assets/i18n/shared';

export const ASSETS_INSURANCE_LINKING_HOME_PATH = 'assets/i18n/insurance-web-link/home';

export const ASSETS_PROFILE_PATH = 'assets/i18n/profile';

export const ASSETS_KTP_PATH = 'assets/i18n/ktp';

export const ASSETS_INSURANCE_LINKING_PATH = 'assets/i18n/insurance-web-link/insurance-linking';

export const ASSETS_INSURANCE_LINKING_PROVIDER_SELECTION_PATH = 'assets/i18n/insurance-web-link/provider-selection';

export const ASSETS_INSURANCE_LINKING_PROVIDER_FORM_PATH = 'assets/i18n/insurance-web-link/provider-linking-form';

export const EMAIL_AUTHENTICATION_PATH = '/insurance/home/email-authentication';

export const GENERALI_INITIATED = 'GENERALI_INITIATED';
